import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Col, Container, Nav, Row } from "reactstrap";
import Lightbox from "react-18-image-lightbox";
import "react-18-image-lightbox/style.css";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedPortFolio } from "../../store/reducer/portFolioReducer";
import CustomPagination from "../pagination";

function Gallerylist() {

    const [activeTab, setActiveTab] = useState("all");
    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 6;

    const dispatch = useDispatch();
    // const portfolioItems = useSelector((state) => state.portFolio.portFolioItems);
    // console.log(JSON.stringify(portfolioItems))
    const portfolioItems = [
        {"id":1,"name":"Inventory Management System","images":"inventory.png","description":"","category":["web"],"client":"","createdby":"","projectcomplated":""},
        {"id":2,"name":"Energy Monitoring System","images":"energy.png","description":"","category":["web"],"client":"","createdby":"","projectcomplated":""},
        {"id":3,"name":"Point of Sales with BT Printer","images":"pos.png","description":"","category":["mobile", "others"],"client":"","createdby":"","projectcomplated":""},
        {"id":4,"name":"IoT Measurement Platform","images":"iot.png","description":"","category":["mobile", "others"],"client":"","createdby":"","projectcomplated":""},
        {"id":5,"name":"Company Profile","images":"06.jpg","description":"","category":["web"],"client":"","createdby":"","projectcomplated":""},
        {"id":6,"name":"Public Open Data Dashboard","images":"public.png","description":"","category":["web"],"client":"","createdby":"","projectcomplated":""},
        {"id":7,"name":"Reservation System","images":"reservation.png","description":"","category":["web", "mobile"],"client":"","createdby":"","projectcomplated":""},
        {"id":8,"name":"Public Places Entrance System","images":"entrance.png","description":"","category":["mobile"],"client":"","createdby":"","projectcomplated":""},
        {"id":9,"name":"Customer Loyalty Programs","images":"customer.png","description":"","category":["mobile"],"client":"","createdby":"","projectcomplated":""},
        {"id":10,"name":"Data Analytics Dashboard","images":"analytic.png","description":"","category":["web"],"client":"","createdby":"","projectcomplated":""},
        
        // {"id":4,"name":"Project Management Tools","images":"04.jpg","description":"","category":["web"],"client":"","createdby":"","projectcomplated":""},
        // {"id":5,"name":"E-commerce Solutions","images":"05.jpg","description":"","category":["web", "mobile"],"client":"","createdby":"","projectcomplated":""},
        // {"id":6,"name":"Membership Platforms","images":"06.jpg","description":"","category":["mobile"],"client":"","createdby":"","projectcomplated":""},
        // {"id":7,"name":"Ticketing System","images":"02.jpg","description":"","category":["web"],"client":"","createdby":"","projectcomplated":""},
        // {"id":10,"name":"Health and Fitness Trackers","images":"01.jpg","description":"","category":["mobile"],"client":"","createdby":"","projectcomplated":""},
        // {"id":11,"name":"Learning and Training Apps","images":"04.jpg","description":"","category":["mobile"],"client":"","createdby":"","projectcomplated":""},
        // {"id":12,"name":"Surveys and Feedback","images":"02.jpg","description":"","category":["mobile"],"client":"","createdby":"","projectcomplated":""},
        // {"id":13,"name":"Food & Service Delivery","images":"03.jpg","description":"","category":["mobile"],"client":"","createdby":"","projectcomplated":""},
        // {"id":14,"name":"Point of Sales","images":"06.jpg","description":"","category":["others"],"client":"","createdby":"","projectcomplated":""},
        // {"id":15,"name":"Ordering Apps","images":"02.jpg","description":"","category":["others","mobile"],"client":"","createdby":"","projectcomplated":""},
        // {"id":16,"name":"Travel Planning and Booking","images":"05.jpg","description":"","category":["mobile"],"client":"","createdby":"","projectcomplated":""}
    ]

    const filteredPortfolioItems = activeTab === "all"
        ? portfolioItems
        : portfolioItems.filter((item) => item.category.some((cat) => cat === activeTab));
    const totalPages = Math.ceil(filteredPortfolioItems.length / itemsPerPage);

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const prevIndex = (photoIndex + filteredPortfolioItems.length - 1) % filteredPortfolioItems.length;
    const nextIndex = (photoIndex + 1) % filteredPortfolioItems.length;

    const openLightbox = (index) => {
        setPhotoIndex(index);
        setIsOpen(true);
    };

    // const handlePrevPage = () => {
    //     if (currentPage > 1) {
    //         setCurrentPage(currentPage - 1);
    //     }
    // };

    // const handleNextPage = () => {
    //     const totalPages = Math.ceil(filteredPortfolioItems.length / itemsPerPage);
    //     if (currentPage < totalPages) {
    //         setCurrentPage(currentPage + 1);
    //     }
    // };
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const visibleItems = filteredPortfolioItems.slice(startIndex, endIndex);

    return (
        <div>
            <section className="container ps-0 pe-0 pb-0">
                <Container>
                    <Row>

                        <Col className="text-center">
                            <div className="portfolio-filter ">
                                <Nav>
                                    <Button
                                        className={activeTab === "all" ? "is-checked mb-3 mb-sm-0" : "mb-3 mb-sm-0"}
                                        onClick={() => handleTabClick("all")}
                                    >
                                        All Works
                                    </Button>
                                    <Button
                                        className={activeTab === "web" ? "is-checked mb-3 mb-sm-0" : "mb-3 mb-sm-0"}
                                        onClick={() => handleTabClick("web")}
                                    >
                                        Web-based System
                                    </Button>
                                    <Button
                                        className={activeTab === "mobile" ? "is-checked mb-3 mb-sm-0" : "mb-3 mb-sm-0"}
                                        onClick={() => handleTabClick("mobile")}
                                    >
                                        Mobile Apps
                                    </Button>
                                    <Button
                                        className={activeTab === "others" ? "is-checked mb-3 mb-sm-0" : "mb-3 mb-sm-0"}
                                        onClick={() => handleTabClick("others")}
                                    >
                                        Others
                                    </Button>
                                </Nav>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <div className="col-lg-12 col-md-12">
                            <div className="grid columns-3 row popup-gallery">
                                <div className="grid-sizer" />
                                {visibleItems.map((item, index) => (
                                    <div class="grid-item col-lg-4 col-md-6 mb-5 cat3">
                                        <div class="portfolio-item position-relative overflow-hidden">
                                            <img class="img-fluid w-100" src={require(`../../assets/images/portfolio/${item.images}`)} alt="testimage" />
                                            <div class="portfolio-title d-flex justify-content-between align-items-center">
                                                <div> <small class="text-light mb-2">{(item.category).join(" | ")}</small>
                                                    <h6 className="btn-link text-white">
                                                        {item.name}
                                                    </h6>
                                                </div>
                                                <Link
                                                    className="popup-img h2 text-white"
                                                    to="/"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        openLightbox(index);
                                                    }}
                                                >
                                                    <i className="la la-plus"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>))}
                            </div>
                        </div>
                    </Row>
                    <Row className="" style={{ display: 'grid', justifyContent: 'center', alignItems: 'center' }}>
                        {filteredPortfolioItems.length > 6 &&
                            <CustomPagination
                                activePage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />}
                    </Row>
                </Container>
            </section>
            {isOpen && (
                <Lightbox
                    mainSrc={require(`../../assets/images/portfolio/${filteredPortfolioItems[photoIndex].images}`)}
                    prevSrc={require(`../../assets/images/portfolio/${filteredPortfolioItems[prevIndex].images}`)}
                    nextSrc={require(`../../assets/images/portfolio/${filteredPortfolioItems[nextIndex].images}`)}
                    onCloseRequest={() => setIsOpen(false)}
                    onMovePrevRequest={() => setPhotoIndex(prevIndex)}
                    onMoveNextRequest={() => setPhotoIndex(nextIndex)}
                />
            )}

        </div>
    );
}

export default Gallerylist;
